import DOMPurify from "dompurify";

const FORBID_TAGS = [
  "style",
  "iframe",
  "object",
  "embed",
  "form",
  "input",
  "button",
  "link",
  "base",
  "meta",
  "svg",
  "audio",
  "video",
  "source",
  "track",
];

const DEFAULT_IMAGE_HOST_ALLOWLIST = ["amazonaws.com"];

let allowDataImagesForCurrentSanitize = false;
let hooksRegistered = false;

const getImageHostAllowlist = () => {
  const fromEnv = process.env.REACT_APP_IMAGE_HOST_ALLOWLIST;
  if (fromEnv && fromEnv.trim()) {
    return fromEnv
      .split(",")
      .map((host) => host.trim())
      .filter(Boolean);
  }
  return DEFAULT_IMAGE_HOST_ALLOWLIST;
};

const isAllowedImageSrc = (src, allowDataImages) => {
  if (!src || typeof src !== "string") {
    return false;
  }

  if (src.startsWith("data:image/") && allowDataImages) {
    return true;
  }

  try {
    const url = new URL(src, window.location.origin);
    if (url.protocol !== "https:") {
      return false;
    }
    const hostname = url.hostname.toLowerCase();
    return getImageHostAllowlist().some(
      (allowed) =>
        hostname === allowed.toLowerCase() ||
        hostname.endsWith(`.${allowed.toLowerCase()}`)
    );
  } catch {
    return false;
  }
};

const registerHooks = () => {
  if (hooksRegistered) {
    return;
  }

  DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
    if (node.nodeName === "IMG" && data.attrName === "src") {
      if (
        !isAllowedImageSrc(data.attrValue, allowDataImagesForCurrentSanitize)
      ) {
        data.keepAttr = false;
      }
    }
  });

  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
      node.setAttribute("rel", "noopener noreferrer");
    }
  });

  hooksRegistered = true;
};

export const sanitizeQuestionHtml = (
  html,
  { allowDataImages = false } = {}
) => {
  if (!html || typeof html !== "string") {
    return html;
  }

  registerHooks();
  allowDataImagesForCurrentSanitize = allowDataImages;

  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true, mathMl: true },
    FORBID_TAGS,
    ADD_ATTR: ["target"],
  });
};
